import { type Module } from "~/foundation/Bootstrapper/types";
import { type StickyBadgeFrontendProps } from "../generated-types";
import "./sticky-badge.scss";
import { isExperienceEditor } from "~/foundation/Helpers/isExperienceEditor.ts";

const StickyBadge: Module<StickyBadgeFrontendProps> = async (element, props) => {
	const badgeImg = element.querySelector("img") as HTMLImageElement;
	const scrollAmount = 160;
	const borderRadius = 5;

	const crop = {
		x: (props?.cropX ?? 0) * (props?.width ?? 0),
		y: (props?.cropY ?? 0) * (props?.height ?? 0),
	};
	const initialPadding = props?.height - crop.y;

	const clipPath = `inset(0px ${props?.width - crop.x}px ${props?.height - crop.y}px 0px round ${borderRadius}px 0 ${borderRadius}px 0)`;
	const hoverClipPath = `inset(0 0 0 0 round ${borderRadius}px)`;

	let lastScrollY = 0;
	let ticking = false;

	const handleScroll = () => {
		lastScrollY = window.scrollY;

		if (!ticking) {
			window.requestAnimationFrame(() => {
				if (lastScrollY < scrollAmount) {
					badgeImg.style.clipPath = hoverClipPath;
					element.style.marginBottom = "0";
					element.classList.add("open");
				} else {
					badgeImg.style.clipPath = clipPath;
					element.style.marginBottom = `-${initialPadding}px`;
					element.classList.remove("open");
				}
				ticking = false;
			});
			ticking = true;
		}
	};

	if (!isExperienceEditor) {
		window.addEventListener("scroll", handleScroll, { passive: true });
	}
};

export default StickyBadge;